<template>
  <tr class="brand-header" v-if="show_brand_header">
    <td :style="`padding: 20px 0; text-align: center; position: relative; background-color: ${backgroundColor || 'transparent'}; padding-top: ${show_full_logo && organization.full_logo ? '0' : '20px'};`">
      <div class="block-wrapper header">
        <b-button
          v-if="!hide_actions"
          id="edit-branding"
          variant="outline-primary"
          class="edit px-2 mr-3 mt-2"
          style="position: absolute; right: 0;"
          :disabled="disabled"
        >
          <i class="fa fa-fw fa-ellipsis-v"></i>
        </b-button>
        <b-popover
          target="edit-branding"
          triggers="focus"
          placementer="bottom"
          :title="trans('header')"
        >
          <p>{{ trans('template_edit_branding') }}</p>
          <p>
            <a :href="editBrandingUrl" class="btn btn-sm btn-primary">
              {{ trans('edit_branding') }}
            </a>
          </p>
          <p>{{ trans('template_edit_branding2') }}</p>
        </b-popover>
      </div>
      <a v-if="organization.url" :href="organization.url" :alt="organization.name" target="_blank" style="text-decoration: none;">
        <img v-if="organization.logo && (!show_full_logo || !organization.full_logo)" :src="organization.logo" height="50" :alt="organization.name" border="0" style="font-size: 15px; line-height: 15px; color: #dddddd;">
        <img v-if="organization.full_logo && !!show_full_logo" :src="organization.full_logo" width="100%" :alt="organization.name" border="0" style="font-size: 15px; line-height: 15px; color: #dddddd;">
        <div v-if="!organization.logo" style="margin: 0 0 10px; color: #555555; font-weight: bold;">{{ organization.name }}</div>
      </a>
      <img v-if="!organization.url && organization.logo && (!show_full_logo || !organization.full_logo)" :src="organization.logo" height="50" :alt="organization.name" border="0" style="font-size: 15px; line-height: 15px; color: #dddddd;">
      <img v-if="!organization.url && organization.full_logo && !!show_full_logo" :src="organization.full_logo" width="100%" :alt="organization.name" border="0" style="font-size: 15px; line-height: 15px; color: #dddddd;">
      <div v-if="!organization.url && !organization.logo" style="margin: 0 0 10px; color: #555555; font-weight: bold;">{{ organization.name }}</div>
    </td>
  </tr>
</template>

<script>

  export default {
    props: {
      organization: Object,
      show_brand_header: {
        type: Boolean,
        default: false,
      },
      show_full_logo: {
        type: Boolean,
        default: false
      },
      hide_actions: {
        type: Boolean,
        default: false,
      },
      backgroundColor: {
        type: String,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
      }
    },
    computed: {
      editBrandingUrl() {
        return `/organization/${this.organization.id}/edit/branding`
      },
    },
  }
</script>